import MyPage from '../../../Commons/Layouts/MyPage';
import Container from './Container';

const PaymentHistory = (props) => {
  return (
    <MyPage>
      <Container {...props} />
    </MyPage>
  );
};

export default PaymentHistory;
